var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.option)?_c('div',{staticClass:"issue_status"},[_c('span',[_vm._v(_vm._s(_vm.option.title))]),_c('span',[_vm._v(_vm._s(_vm._f("date")(_vm.option.start_at))+" - "+_vm._s(_vm._f("date")(_vm.option.end_at)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }